/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BurnNftRewardBody
 */
export interface BurnNftRewardBody {
    /**
     * 
     * @type {string}
     * @memberof BurnNftRewardBody
     */
    transactionHash?: string;
}

export function BurnNftRewardBodyFromJSON(json: any): BurnNftRewardBody {
    return BurnNftRewardBodyFromJSONTyped(json, false);
}

export function BurnNftRewardBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BurnNftRewardBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionHash': !exists(json, 'transactionHash') ? undefined : json['transactionHash'],
    };
}

export function BurnNftRewardBodyToJSON(value?: BurnNftRewardBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactionHash': value.transactionHash,
    };
}


